import React, { useState } from 'react';
import { X, Star, Minus, Plus, ShoppingBag, Building2, Truck } from 'lucide-react';
import { toast } from 'sonner';

const notify = (msg) => toast.success(msg, { style: { background: '#0f1622', color: '#fff', border: '1px solid #1c2634' } });

export function b2bInfo(product) {
  const wholesale = Math.round(product.price * 0.6);
  const moq = product.cat === 'Tech' ? 10 : 50;
  return { wholesale, moq };
}

export default function ProductSheet({ product, initialB2B = false, onClose }) {
  const { wholesale, moq } = b2bInfo(product || {});
  const [b2b, setB2b] = useState(initialB2B);
  const [qty, setQty] = useState(initialB2B ? moq : 1);
  if (!product) return null;

  const unit = b2b ? wholesale : product.price;
  const min = b2b ? moq : 1;
  const step = b2b ? 10 : 1;
  const total = unit * qty;

  const switchMode = (v) => { setB2b(v); setQty(v ? moq : 1); };
  const buy = () => { onClose(); notify(b2b ? `Bulk order placed · ${qty} units` : `${product.name} added to cart`); };

  return (
    <div className="fixed inset-0 z-[65] flex items-end justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative w-full max-w-[440px] bg-[#0c1420] rounded-t-3xl p-5 animate-pop-in" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 z-10"><X size={22} className="text-[#8b95a5]" /></button>
        <div className="flex gap-4">
          <img src={product.image} alt="" className="w-28 h-28 rounded-2xl object-cover bg-white/5" />
          <div className="flex-1 min-w-0 pr-6">
            <p className="text-[11px] text-[#8b95a5]">{product.seller}</p>
            <h3 className="text-[16px] font-bold text-white leading-tight mt-0.5">{product.name}</h3>
            <div className="flex items-center gap-1 mt-1">
              <Star size={13} className="fill-[#f5a524] text-[#f5a524]" />
              <span className="text-[12px] text-[#c4ccd8]">{product.rating}</span>
            </div>
            <p className="text-[20px] font-bold text-white mt-2">₹{unit.toLocaleString()}
              {b2b && <span className="text-[12px] font-normal text-[#8b95a5]"> /unit</span>}
            </p>
          </div>
        </div>

        <div className="flex bg-[#0a0f18] rounded-xl p-1 mt-4">
          <button onClick={() => switchMode(false)} className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[13px] font-semibold transition-colors ${!b2b ? 'bg-[#2f8bff] text-white' : 'text-[#8b95a5]'}`}>
            <ShoppingBag size={15} /> Retail
          </button>
          <button onClick={() => switchMode(true)} className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[13px] font-semibold transition-colors ${b2b ? 'bg-[#2f8bff] text-white' : 'text-[#8b95a5]'}`}>
            <Building2 size={15} /> B2B / Wholesale
          </button>
        </div>

        {b2b && (
          <div className="flex items-center gap-2 mt-3 text-[12px] text-[#8b95a5]">
            <Truck size={14} className="text-[#2f8bff]" /> Min. order {moq} units · 40% off retail · GST invoice
          </div>
        )}

        <div className="flex items-center justify-between mt-4">
          <span className="text-[14px] text-[#c4ccd8]">Quantity</span>
          <div className="flex items-center gap-3">
            <button onClick={() => setQty((q) => Math.max(min, q - step))} className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center"><Minus size={16} className="text-white" /></button>
            <span className="text-[16px] font-bold text-white w-10 text-center">{qty}</span>
            <button onClick={() => setQty((q) => q + step)} className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center"><Plus size={16} className="text-white" /></button>
          </div>
        </div>

        <button onClick={buy} className="w-full mt-5 py-3.5 rounded-xl bg-[#2f8bff] text-white text-[15px] font-bold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
          <ShoppingBag size={18} /> {b2b ? `Request quote · ₹${total.toLocaleString()}` : `Buy now · ₹${total.toLocaleString()}`}
        </button>
      </div>
    </div>
  );
}
